var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slider-container"},[_c('Transition',{attrs:{"duration":_vm.transitionName !== '' ? 500 : 0,"name":_vm.transitionName}},[_c('div',{key:_vm.routerViewKey},[_c('RouterView',_vm._b({},'RouterView',_vm.$attrs,false))],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }